export default __webpack_public_path__ + "static/media/4.dc32eee1.png";